<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import CpButtonIcon from '~/components/cp/CpButtonIcon/CpButtonIcon.vue';
  import CpPartnerLogo from '~/components/cp/CpPartnerLogo/CpPartnerLogo.vue';
  import CpPressable from '~/components/cp/CpPressable/CpPressable.vue';
  import type {ICpRouteLocationNamedRaw} from '~/utils/services/screens';

  withDefaults(defineProps<{
    to?: string | ICpRouteLocationNamedRaw,
    label: string,
    icon: string,
    accordion?: boolean,
    divider?: boolean,
    partnerLogo?: 'google'|'x'|'facebook'|'discord' | undefined,
    critical?: boolean
    target?: string
  }>(), {
    accordion: false,
    divider: false,
    partnerLogo: undefined,
    to: undefined,
  });

  const emit = defineEmits({
    showLogin: null,
  });

  const specialCases = [
    'https://www.cyberpuerta.mx/mis-direcciones/',
    'https://www.cyberpuerta.mx/Historial-de-pedidos/',
    'https://cyberpuerta.breezy.hr/',
  ];

  function showLogin(to: string) {
    if (to === 'https://cyberpuerta.breezy.hr/') {
      window.open(to, '_blank');
      return;
    }
    if (specialCases.includes(to)) {
      emit('showLogin', to);
    }
  }

  const {b, em} = useCpBem('cp-body-action');
</script>

<template>
    <div :class="b">
        <CpPressable :href="specialCases.includes(`${to}`) ? '' : to" :target="target" @click="showLogin(`${to}`)">
            <div :class="em('container', {divider: divider, accordion: accordion})">
                <div v-if="!accordion">
                    <CpPartnerLogo v-if="partnerLogo" :kind="partnerLogo" />
                    <CpIconStandard v-else :icon="icon" kind="standard" :type="critical ? 'critical' : 'primary'" />
                </div>
                <CpText variant="body-regular" :type="critical ? 'critical' : 'primary'">
                    {{ label }}
                </CpText>
                <CpButtonIcon v-if="accordion" kind="accordion" type="primary" />
            </div>
        </CpPressable>
    </div>
</template>

<style scoped lang="scss">
    .cp-body-action {
      display: flex;
      &__container {
        display: flex;
        gap: 8px;
        padding: 16px;
        align-items: center;
        flex: 1;
        &--divider {
          border-bottom: 1px solid var(--color-neutral-extra-light);
        }
        &--accordion {
          justify-content: space-between;
        }
      }
    }
</style>
